import * as React from "react";
import Box from "@mui/material/Box";
import {
    getPatientImage,
    getPatientList,
    getPayedPatientInfo,
    getReservedSubTimesEachDay,
    updatePatientInformation,
} from "../../api/routes";
import { useEffect, useState } from "react";
import { getTransition, getPatientHealthInfo } from "../../api/routes";
import MDBox from "components/MDBox";
import {
    Backdrop,
    CircularProgress,
    Divider,
    Icon,
    Modal,
    Switch,
    Tab,
    Tabs,
    Select,
    FormControl,
    MenuItem,
    InputLabel,
} from "@mui/material";
import seperate from "components/seperate";
import TabPanel from "./../../components/TabPanel";
import MDTypography from "./../../components/MDTypography/index";
import MDInput from "./../../components/MDInput/index";
import useStyle from "./style";
import queryString from "components/queryString";
import { toast } from "react-toastify";

function createData(patientId, isCheck, insuranceRefCode, refcode, firstName, lastName, date, groupName, reservationTime, nationalCode, mobileNumber, reference, options) {
    return {
        patientId,
        isCheck,
        refcode,
        insuranceRefCode,
        firstName,
        lastName,
        date,
        groupName,
        reservationTime,
        nationalCode,
        mobileNumber,
        reference,
        options,
    };
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    height: "fit-content",
    overflowY: "auto",
    "@media (max-width: 700px)": {
        width: "95%",
    },
};

export default function PatientListTable({ reservationDate }) {
    const classes = useStyle();
    /* ------------------------ */
    const [patientList, setPatientList] = useState([]);
    const [transaction, setTransaction] = useState([]);
    const [search, setSearch] = useState("");
    const [image, setImage] = useState([]);
    const [openInfo, setOpenInfo] = useState(false);
    const [tab, setTab] = useState(0);
    const [refId, setRefId] = useState("");
    const [patientInfoWithRefId, setPatientInfoWithRefId] = useState([]);
    const [reservedSubTimes, setReservedSubTimes] = useState([]);
    const handleCloseInfo = () => setOpenInfo(false);
    const handleOpenInfo = () => setOpenInfo(true);
    const [searchParam, setSearchParam] = useState(0);
    const [loading, setLoading] = useState(false);

    const [healthInfo, setHealthInfo] = useState([]);
    const [open, setOpen] = useState({
        open1: false,
        open2: false,
        open3: false,
    });

    const handleClose = (key) => {
        setOpen((prev) => ({
            ...prev,
            [key]: false,
        }));
    };

    const handleOpen = (key) => {
        setOpen((prev) => ({
            ...prev,
            [key]: true,
        }));
    };

    useEffect(() => {
        if (refId && refId !== "") {
            setLoading(true);
            getPayedPatientInfo(refId, (isOk, patientInfo) => {
                if (!isOk) return toast.error(patientInfo.message);
                else {
                    if (patientInfo.length === 0) return toast.error("اطلاعات بیمار در سیستم ثبت نشده است");
                    setPatientInfoWithRefId(patientInfo);
                    getTransition(patientInfo[0].patientId, patientInfo[0].reservedSubTimesId, (isOk, data) => {
                        if (!isOk) return toast.error(data.message);
                        else {
                            setTransaction(data);
                            getPatientHealthInfo(patientInfo[0].patientId, (isOk, data) => {
                                if (!isOk) return toast.error(data.message);
                                else {
                                    setHealthInfo(data);
                                    getPatientImage(patientInfo[0].patientId, (isOk, data) => {
                                        if (!isOk) return toast.error(data.message);
                                        else {
                                            setImage(data);
                                            setLoading(false);
                                            return handleOpenInfo();
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
    }, [refId]);

    useEffect(() => {
        if (reservationDate) {
            setLoading(true);
            const query = {
                date: reservationDate,
            };
            getPatientList(queryString(query), (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else {
                    return setPatientList(data.data);
                }
            });
            getReservedSubTimesEachDay(reservationDate, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else {
                    setLoading(false);
                    return setReservedSubTimes(data);
                }
            });
        }
    }, [reservationDate]);
    const transitions = (item) => {
        setLoading(true);
        getTransition(item.patientId, item.reservedSubTimesId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else {
                setTransaction(data);
                setLoading(false);
                handleOpen("open1");
            }
        });
    };
    const patientImage = (item) => {
        setLoading(true);
        getPatientImage(item.patientId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else {
                setLoading(false);
                setImage(data);
                handleOpen("open2");
            }
        });
    };
    const patientHealth = (item) => {
        setLoading(true);
        getPatientHealthInfo(item.patientId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else {
                setLoading(false);
                setHealthInfo(data);
                handleOpen("open3");
            }
        });
    };
    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
    };

    const rows = patientList?.map((item) => createData(item.patientId, item.isCheck, item.insuranceRefCode, item.refcode, item.firstName, item.lastName, `${String(item.reservationDate).slice(0, 4)}/${String(item.reservationDate).slice(4, 6)}/${String(item.reservationDate).slice(6)}`, item.groupName, item.reservationTime, item.nationalCode, item.mobileNumber, item.reference,
        <div style={{ display: "flex", alignItems: "center" }}>
            <div onClick={() => transitions(item)}
                 className={classes.transactionParent}>{(item.transactionPrice ? seperate(item.transactionPrice) : 0) + " تومان"}</div>
            {item.isImage !== null && <Icon style={{ cursor: "pointer", color: "#acacac", marginRight: "0.5rem" }}
                                            onClick={() => patientImage(item)}>image</Icon>}
            {item.isPatientHealthInfo !== null &&
                <Icon style={{ cursor: "pointer", color: "#acacac", marginRight: "0.5rem" }}
                      onClick={() => patientHealth(item)}>medical_information</Icon>}
            <Icon style={{ cursor: "pointer", color: "#acacac", marginRight: "0.5rem" }}
                  onClick={() => setRefId(item.patientId)}>info</Icon>
        </div>));
    const isCheckHandle = (event, patientId) => {
        setLoading(true);
        setPatientList(() => patientList.map(patient => {
            if (patient.patientId === patientId)
                return { ...patient, isCheck: event.target.checked };
            else return patient;
        }));
        updatePatientInformation(patientId, { isCheck: +event.target.checked }, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
            } else {
                setLoading(false);
            }
        });
    };
    return (
        <>
            <Box sx={{ width: "100%" }}>
                <section style={{ display: "flex", alignItems: "center", paddingRight: "2rem" }}>
                    <FormControl sx={{ width: "300px" }}>
                        <InputLabel>پارامتر جستجو</InputLabel>
                        <Select value={searchParam} onChange={(event) => setSearchParam(event.target.value)}
                                label="پارامتر جستجو" sx={{ height: "44.3px" }}>
                            <MenuItem value={0}>نام و نام خانوادگی</MenuItem>
                            <MenuItem value={1}>کد ملی</MenuItem>
                            <MenuItem value={2}>شماره تماس</MenuItem>
                            <MenuItem value={3}>شماره پیگیری</MenuItem>
                        </Select>
                    </FormControl>
                    <MDInput value={search} onChange={(event) => setSearch(event.target.value)} type="text"
                             label="جستجو" sx={{ margin: "0.75rem", width: "300px" }} />
                </section>
                <div style={{marginRight:'2rem',marginBottom:30}}>
                    <p style={{ fontSize: 14 }}>زمان های پرشده</p>
                    <div style={{ display: "flex" }}>
                        {reservedSubTimes.map(item => item.isPanel && item.isPayed && item.isReserved &&
                            <section style={{
                                backgroundColor: "#ef4444",
                                padding: "0.3rem",
                                borderRadius: "8px",
                                marginRight:2
                            }}> <MDTypography component="p" variant="caption" style={{ color: "white" }} fontWeight="medium">{item.subTime}</MDTypography></section>)}
                    </div>
                </div>
                {rows.length > 0 ?
                    <div className={classes.patientListParent}>
                        {rows.filter(item => search !== "" ? searchParam === 0 ? (item.firstName + " " + item.lastName).match(new RegExp(`.*${search}.*`, "i")) : searchParam === 1 ? item.nationalCode.match(new RegExp(`.*${search}.*`, "i")) :
                            searchParam === 2 ? item.mobileNumber.match(new RegExp(`.*${search}.*`, "i")) : searchParam === 3 && String(item.patientId).match(new RegExp(`.*${search}.*`, "i")) : true).map(row =>
                            <section key={row.patientId}>
                                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "0.5rem" }}>
                                    <section style={{ display: "flex", alignItems: "center" }}>
                                        <section
                                            style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            <p style={{
                                                color: "#c2c2c2",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                            }}>{row.reservationTime}</p>
                                            <Switch checked={row.isCheck}
                                                    onChange={(event) => isCheckHandle(event, row.patientId)}
                                                    color={"success"} />
                                        </section>
                                        <section className={classes.patientInfoParent}>
                                            <p className={classes.patientName}>
                                                {row.firstName + " " + row.lastName}
                                            </p>
                                            <p className={classes.nationalCode}>{"کد ملی: " + row.nationalCode}</p>
                                            <p className={classes.mobileGroupName}>{row.groupName}</p>
                                            <p style={{
                                                color: "#c2c2c2",
                                                fontSize: "12px",
                                            }}>{"کد پیگیری: " + row.patientId}</p>
                                            {row.reference === "panel" &&
                                                <p style={{ color: "#4ade80", fontSize: 12, fontWeight: "bold" }}>رزرو
                                                    از پنل</p>}

                                            {row.insuranceRefCode && <p style={{
                                                color: "#c2c2c2",
                                                fontSize: "12px",
                                            }}>{"کد رهگیری بیمه: " + row.insuranceRefCode}</p>}
                                        </section>
                                        <section className={classes.mobileNumberParent}>
                                            <p style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}>{row.mobileNumber}<Icon>call</Icon></p>
                                            <p style={{ color: "#c2c2c2", fontSize: "12px" }}>{row.groupName}</p>
                                        </section>
                                    </section>
                                    <section>{row.options}</section>

                                </div>
                                <Divider /></section>)}
                    </div> : <p style={{ margin: "2rem" }}>بیماری برای این روز نوبت نگرفته است.</p>}
                <Modal open={open.open1} onClose={() => handleClose("open1")}>
                    <MDBox sx={style}>
                        <p>لیست تراکنش ها:</p>
                        {transaction.length > 0 ? transaction.map((item) => <div key={item.transitionId} style={{
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                            padding: "1rem",
                            margin: "1rem 0",
                        }}>
                            <section style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                fontSize: "14px",
                            }}>
                                <p>زمان :</p>
                                {item.transactionDate &&
                                    <p>{`${item.transactionDate.slice(8, 10)}:${item.transactionDate.slice(10, 12)}:${item.transactionDate.slice(12, 14)}  ${item.transactionDate.slice(0, 4)}/${item.transactionDate.slice(4, 6)}/${item.transactionDate.slice(6, 8)}`}</p>}
                            </section>
                            <hr style={{ margin: "1rem 0" }} />
                            <section style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                fontSize: "14px",
                            }}>
                                <p>مبلغ :</p>
                                <p>{seperate(item.price)} تومان</p>
                            </section>
                            <hr style={{ margin: "1rem 0" }} />
                            {item.success && <>
                                <section style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    fontSize: "14px",
                                }}>
                                    <p>شماره پیگیری :</p>
                                    <p>{item.refId}</p>
                                </section>
                                <hr style={{ margin: "1rem 0" }} />
                            </>}
                            <section style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                fontSize: "14px",
                            }}>
                                <p>وضعیت پرداخت :</p>
                                <p>{item.success ? "موفق" : "ناموفق"}</p>
                            </section>
                        </div>) : <p>تراکنشی ثبت نشده است!</p>}
                    </MDBox>
                </Modal>
                <Modal open={open.open2} onClose={() => handleClose("open2")}>
                    <MDBox sx={style}>
                        {image.length > 0 ? image.map((item) => <img key={item.fileId}
                                                                     src={`data:image/jpeg;base64,${item.fileSrc}`}
                                                                     alt="prescription" style={{
                            width: "100%",
                            height: "300px",
                            objectFit: "contain",
                        }} />) : <p>نسخه ایی آپلود نشده است!</p>}
                    </MDBox>
                </Modal>
                <Modal open={open.open3} onClose={() => handleClose("open3")}>
                    <MDBox sx={style}>
                        <p>لیست اطلاعات سلامت بیمار:</p>
                        {healthInfo.length > 0 ? healthInfo.map(item =>
                            <p key={item.patientHealthInfoId}
                               style={{ fontSize: "14px", margin: "0.5rem 0" }}>{item.text}(دارد)</p>,
                        ) : <p>اطلاعات سلامتی ثبت نشده است!</p>}
                    </MDBox>
                </Modal>
                <Modal open={openInfo} onClose={handleCloseInfo}>
                    <MDBox sx={style}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                value={tab}
                                onChange={handleChangeTab}
                                textColor="primary"
                                indicatorColor="primary"
                            >
                                <Tab value={0} label="اطلاعات شخصی" className="font-bold" />
                                <Tab value={1} label="لیست تراکنش ها" className="font-bold" />
                                <Tab value={2} label="اطلاعات سلامت" className="font-bold" />
                            </Tabs>
                        </Box>
                        <TabPanel value={tab} index={0}>
                            {patientInfoWithRefId.length > 0 ? <div>
                                <section className={classes.patientFullInfoParent}>
                                    <MDTypography variant="h6">شناسه سناریو
                                        : {patientInfoWithRefId[0].groupName}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>تاریخ رزرو
                                        : {`${patientInfoWithRefId[0].reservationTime}  ${String(patientInfoWithRefId[0].reservationDate).slice(0, 4)}/${String(patientInfoWithRefId[0].reservationDate).slice(4, 6)}/${String(patientInfoWithRefId[0].reservationDate).slice(6)}`}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>نام و خانوادگی
                                        : {patientInfoWithRefId[0].firstName + " " + patientInfoWithRefId[0].lastName}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>کد ملی
                                        : {patientInfoWithRefId[0].nationalCode}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>شماره موبایل
                                        : {patientInfoWithRefId[0].mobileNumber}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>سن
                                        بیمار: {patientInfoWithRefId[0].age ? patientInfoWithRefId[0].age : "ثبت نشده"}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>وزن
                                        بیمار: {patientInfoWithRefId[0].weight ? patientInfoWithRefId[0].weight : "ثبت نشده"}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>کد
                                        پیگیری: {patientInfoWithRefId[0].patientId ? patientInfoWithRefId[0].patientId : "ثبت نشده"}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>نوع بیمه درمانی
                                        : {patientInfoWithRefId[0].mainInsuranceName ? patientInfoWithRefId[0].mainInsuranceName : "ثبت نشده"}</MDTypography>
                                    <MDTypography variant="h6" style={{ margin: "0.75rem 0" }}>نوع بیمه تکمیلی
                                        : {patientInfoWithRefId[0].InsuranceName ? patientInfoWithRefId[0].InsuranceName : "ثبت نشده"}</MDTypography>
                                </section>
                            </div> : <p style={{ paddingTop: "1rem" }}>کاربر یافت نشد.</p>}
                        </TabPanel>
                        <TabPanel value={tab} index={1}>
                            {(patientInfoWithRefId.length > 0 && transaction.length > 0) ? transaction.map((item) =>
                                <div key={item.transitionId}
                                     style={{ borderBottom: "1px solid #ccc", padding: "1rem", margin: "1rem 0" }}>
                                    <section style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        fontSize: "14px",
                                    }}>
                                        <p>زمان :</p>
                                        {item.transactionDate &&
                                            <p>{`${item.transactionDate.slice(8, 10)}:${item.transactionDate.slice(10, 12)}:${item.transactionDate.slice(12, 14)}  ${item.transactionDate.slice(0, 4)}/${item.transactionDate.slice(4, 6)}/${item.transactionDate.slice(6, 8)}`}</p>}
                                    </section>
                                    <hr style={{ margin: "1rem 0" }} />
                                    <section style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        fontSize: "14px",
                                    }}>
                                        <p>مبلغ :</p>
                                        <p>{seperate(item.price)} تومان</p>
                                    </section>
                                    <hr style={{ margin: "1rem 0" }} />
                                    {item.success && <>
                                        <section style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            fontSize: "14px",
                                        }}>
                                            <p>شماره پیگیری :</p>
                                            <p>{item.refId}</p>
                                        </section>
                                        <hr style={{ margin: "1rem 0" }} />
                                    </>}
                                    <section style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        fontSize: "14px",
                                    }}>
                                        <p>وضعیت پرداخت :</p>
                                        <p>{item.success ? "موفق" : "ناموفق"}</p>
                                    </section>
                                </div>) : <p style={{ paddingTop: "1rem" }}>تراکنشی ثبت نشده است!</p>}
                        </TabPanel>
                        <TabPanel value={tab} index={2}>
                            {healthInfo.length > 0 ? healthInfo.map(item =>
                                <p key={item.patientHealthInfoId}
                                   style={{ fontSize: "14px", margin: "1rem 0.5rem" }}>{item.text}(دارد)</p>,
                            ) : <p style={{ paddingTop: "1rem" }}>اطلاعات سلامتی ثبت نشده است!</p>}
                        </TabPanel>
                    </MDBox>
                </Modal>
                <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Box>
        </>
    );
}
